// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	font-family: Arial, Helvetica, sans-serif;

	--font-0: 8px;
	--font-1: 10px;
	--font-2: 12px;
	--font-3: 14px;
	--font-4: 16px;
	--font-5: 18px;
	--font-6: 20px;
	--font-7: 24px;
	--font-8: 28px;
	--font-9: 32px;
	--font-10: 36px;
}

@media(max-width: 1300px) {
	:root {
		--font-0: 6px;
		--font-1: 8px;
		--font-2: 10px;
		--font-3: 12px;
		--font-4: 14px;
		--font-5: 16px;
		--font-6: 18px;
		--font-7: 20px;
		--font-8: 24px;
		--font-9: 28px;
		--font-10: 32px;
	}
}

@media(max-width: 1100px) {
	:root {
		--font-0: 5px;
		--font-1: 7px;
		--font-2: 9px;
		--font-3: 11px;
		--font-4: 13px;
		--font-5: 15px;
		--font-6: 17px;
		--font-7: 19px;
		--font-8: 21px;
		--font-9: 23px;
		--font-10: 27px;
	}
}

@media(min-width: 1500px) {
	:root {
		
		--font-0: 10px;
		--font-1: 12px;
		--font-2: 14px;
		--font-3: 16px;
		--font-4: 18px;
		--font-5: 20px;
		--font-6: 24px;
		--font-7: 28px;
		--font-8: 32px;
		--font-9: 36px;
		--font-10: 40px;
	}
}

@media(min-width: 2000px) {
	:root {
		
		--font-0: 14px;
		--font-1: 16px;
		--font-2: 18px;
		--font-3: 20px;
		--font-4: 24px;
		--font-5: 28px;
		--font-6: 32px;
		--font-7: 36px;
		--font-8: 40px;
		--font-9: 44px;
		--font-10: 48px;
	}
}`, "",{"version":3,"sources":["webpack://./src/Theme/Font/font.css"],"names":[],"mappings":"AAAA;CACC,yCAAyC;;CAEzC,aAAa;CACb,cAAc;CACd,cAAc;CACd,cAAc;CACd,cAAc;CACd,cAAc;CACd,cAAc;CACd,cAAc;CACd,cAAc;CACd,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,aAAa;EACb,aAAa;EACb,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;CAChB;AACD;;AAEA;CACC;EACC,aAAa;EACb,aAAa;EACb,aAAa;EACb,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;CAChB;AACD;;AAEA;CACC;;EAEC,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;CAChB;AACD;;AAEA;CACC;;EAEC,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;CAChB;AACD","sourcesContent":[":root {\r\n\tfont-family: Arial, Helvetica, sans-serif;\r\n\r\n\t--font-0: 8px;\r\n\t--font-1: 10px;\r\n\t--font-2: 12px;\r\n\t--font-3: 14px;\r\n\t--font-4: 16px;\r\n\t--font-5: 18px;\r\n\t--font-6: 20px;\r\n\t--font-7: 24px;\r\n\t--font-8: 28px;\r\n\t--font-9: 32px;\r\n\t--font-10: 36px;\r\n}\r\n\r\n@media(max-width: 1300px) {\r\n\t:root {\r\n\t\t--font-0: 6px;\r\n\t\t--font-1: 8px;\r\n\t\t--font-2: 10px;\r\n\t\t--font-3: 12px;\r\n\t\t--font-4: 14px;\r\n\t\t--font-5: 16px;\r\n\t\t--font-6: 18px;\r\n\t\t--font-7: 20px;\r\n\t\t--font-8: 24px;\r\n\t\t--font-9: 28px;\r\n\t\t--font-10: 32px;\r\n\t}\r\n}\r\n\r\n@media(max-width: 1100px) {\r\n\t:root {\r\n\t\t--font-0: 5px;\r\n\t\t--font-1: 7px;\r\n\t\t--font-2: 9px;\r\n\t\t--font-3: 11px;\r\n\t\t--font-4: 13px;\r\n\t\t--font-5: 15px;\r\n\t\t--font-6: 17px;\r\n\t\t--font-7: 19px;\r\n\t\t--font-8: 21px;\r\n\t\t--font-9: 23px;\r\n\t\t--font-10: 27px;\r\n\t}\r\n}\r\n\r\n@media(min-width: 1500px) {\r\n\t:root {\r\n\t\t\r\n\t\t--font-0: 10px;\r\n\t\t--font-1: 12px;\r\n\t\t--font-2: 14px;\r\n\t\t--font-3: 16px;\r\n\t\t--font-4: 18px;\r\n\t\t--font-5: 20px;\r\n\t\t--font-6: 24px;\r\n\t\t--font-7: 28px;\r\n\t\t--font-8: 32px;\r\n\t\t--font-9: 36px;\r\n\t\t--font-10: 40px;\r\n\t}\r\n}\r\n\r\n@media(min-width: 2000px) {\r\n\t:root {\r\n\t\t\r\n\t\t--font-0: 14px;\r\n\t\t--font-1: 16px;\r\n\t\t--font-2: 18px;\r\n\t\t--font-3: 20px;\r\n\t\t--font-4: 24px;\r\n\t\t--font-5: 28px;\r\n\t\t--font-6: 32px;\r\n\t\t--font-7: 36px;\r\n\t\t--font-8: 40px;\r\n\t\t--font-9: 44px;\r\n\t\t--font-10: 48px;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
